import React, { useRef, useState } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import Path from "../../common/Path";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { Col, Row } from "react-bootstrap";
import whats from "../../assets/whatsapp.svg";
import ContactUsService from "../../services/ContactUsService";
import { toast } from "react-toastify";
import bg from "../../assets/bg.jpg";
import contactImg from "../../assets/contact-img.svg";

const Contact = () => {
	const [formData, setFormData] = useState({
		f_name: "",
		l_name: "",
		email: "",
		phone: "",
		message: "",
	});
	const formRef = useRef(null);
	const { t } = useTranslation();
	const contactUsService = new ContactUsService();

	const submit = (e) => {
		e.preventDefault();
		if (!formData.message) {
			toast.error(t("Message Required."));
			return;
		}

		contactUsService
			.create(formData)
			.then((res) => {
				if (res?.status === 201) {
					toast.success(t("Message Sent Successfully."));
					setFormData({
						f_name: "",
						l_name: "",
						email: "",
						phone: "",
						message: "",
					});
					formRef.current.reset();
				}
			})
			.catch((e) => toast.error(e?.response?.data?.message));
	};

	return (
		<div className="contact">
			<div
				className="banner"
				style={{
					backgroundImage: `url(${bg})`,
				}}>
				<p className="title">{t("Contact Us")}</p>
				<p className="sub-title">{t("Know more about Us")}</p>
			</div>
			<div className="container">
				<AvForm
					ref={formRef}
					className="form-horizontal login-form"
					onValidSubmit={submit}>
					<Row>
						<Col md={6}>
							<div className="getInTouch">
								<h4>{t("Contact us")}</h4>
								<div className="row">
									<div className="col-6">
										<AvField
											label={t("First Name")}
											type="text"
											placeholder={t("First Name")}
											bsSize="lg"
											name="f_name"
											validate={{
												required: {
													value: true,
													errorMessage: `${t("This Field is required")}`,
												},
											}}
											value={formData.f_name}
											onChange={(e) =>
												setFormData({ ...formData, f_name: e.target.value })
											}
										/>
									</div>
									<div className="col-6">
										<AvField
											label={t("Last Name")}
											type="text"
											placeholder={t("Last Name")}
											bsSize="lg"
											name="l_name"
											validate={{
												required: {
													value: true,
													errorMessage: `${t("This Field is required")}`,
												},
											}}
											value={formData.l_name}
											onChange={(e) =>
												setFormData({ ...formData, l_name: e.target.value })
											}
										/>
									</div>
								</div>
								<div>
									<AvField
										label={t("Email")}
										type="email"
										placeholder={t("Email")}
										bsSize="lg"
										name="email"
										validate={{
											required: {
												value: true,
												errorMessage: `${t("This Field is required")}`,
											},
										}}
										value={formData.email}
										onChange={(e) =>
											setFormData({ ...formData, email: e.target.value })
										}
									/>
								</div>
								<div>
									<AvField
										label={t("Phone")}
										type="number"
										placeholder={t("Phone")}
										bsSize="lg"
										name="phone"
										validate={{
											required: {
												value: true,
												errorMessage: `${t("This Field is required")}`,
											},
										}}
										value={formData.email}
										onChange={(e) =>
											setFormData({ ...formData, phone: e.target.value })
										}
									/>
								</div>
								<div>
									<label>{t("Message")}</label>
									<textarea
										rows={8}
										className="w-100"
										placeholder={t("Message")}
										required
										value={formData?.message}
										style={{
											border: "1px solid #dedede",
											borderRadius: "8px",
											padding: "8px",
											height: "90px",
										}}
										onChange={(e) => {
											setFormData({ ...formData, message: e.target.value });
										}}
									/>
								</div>
								<button type="submit" className="mt-3 send">
									{t("Send")}
								</button>
							</div>
						</Col>
						<Col md={6}>
							<div>
								<img src={contactImg} alt="contactImg" />
							</div>
						</Col>
					</Row>
				</AvForm>
			</div>
		</div>
	);
};

export default Contact;
